<template>
  <v-container style="max-width:800px;">
    <v-card class="noisy-back" style="background-color:#0086D2;margin-bottom:160px;">
      <v-card-title class="font_rockn white--text">発送する商品を選択してください</v-card-title>
      <v-card-subtitle class="white--text">発送されない商品はポイントに還元されます</v-card-subtitle>
      <v-card-text>
        <p style="border:solid 1px;background-color:white;" class="rounded pa-2">
          <v-icon small class="pr-1">mdi-information-outline</v-icon>
          次回の発送確定締切日 {{ getNextFriday() }} 23:59:59<br>
          <span style="font-size: 12px;" class="ml-6">※確定日までは発送をキャンセルできます</span>
        </p>
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6" v-for="card in cards" :key="card.order_id">
            <v-card :class="{transColor:selected.map(item=>item.order_id).includes(card.order_id)}" style="outline: solid;outline-offset: -5px;" @click="select(card)">
              <v-img class="card_image" :class="{kira:selected.map(item=>item.order_id).includes(card.order_id)}" :src="card.image"></v-img>
              <v-img v-if="selected.map(item=>item.order_id).includes(card.order_id)" class="card_background" :src="card.image"></v-img>
              <v-card-text :class="{result_card:selected.map(item=>item.order_id).includes(card.order_id)}">
                <p class="mb-0 text-right">{{card.card_rarity}} / <span class="font-weight-bold">{{card.card_name}}</span></p>
                <p class="mb-0 text-right">{{card.pack_number}} | {{card.card_list_number}}</p>
                <p class="mb-0 text-right"><span class="font-weight-bold" style="color:#bf9507;">{{card.return_point}}</span> pt</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-footer fixed class="result_footer">
      <v-container style="max-width:800px;">
        <v-row>
          <v-col cols="4">
            <p class="text-subtitle-2">還元ポイント</p>
            <p class="mb-0"><span class="font-weight-bold" style="color:#bf9507;">{{nonselected_return_point}}</span> pt</p>
            <p>{{cards.length-selected.length}} / {{cards.length}}</p>
          </v-col>
          <v-col cols="8">
            <v-btn block class="text-subtitle-2 pl-1 pr-1 mb-5 white--text" style="border:solid black;" color="#bf9507" @click="dialog=true;flag=1;">すべてポイント還元する ({{cards.length}}枚)</v-btn>
            <v-btn block class="text-subtitle-2 pl-1 pr-1 white--text" :disabled="selected.length==0" style="border:solid black;" color="#0086D2" @click="dialog=true;flag=2;">発送する ({{selected.length}}枚)</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-dialog v-model="dialog" width="350px">
      <v-card v-if="flag==1">
        <v-card-text class="pt-5">
          <p class="font-weight-black text-center" style="font-size:16px;">すべてのカードがポイント還元されます</p>
          <p>選択中のカードも含め、すべてのカードがポイントに還元され、保有ptに加算されます</p>
          <v-row>
            <v-col><p class="text-left" style="font-size:12px;">還元カード <span class="font-weight-bold" style="font-size:16px;">{{cards.length}}</span> /{{cards.length}}枚</p></v-col>
            <v-col><p class="text-right" style="font-size:12px;">計 <span class="font-weight-bold" style="font-size:16px;color:#bf9507;">{{sum_return_point}}</span> pt</p></v-col>
          </v-row>
          <v-btn block class="mt-5 mb-4 white--text" style="border:solid black;" color="#bf9507" @click="dialog=false;flag=0;returnAllCards();">確定する</v-btn>
          <v-btn block style="border:solid black;" @click="dialog=false;flag=0;">戻る</v-btn>
        </v-card-text>
      </v-card>
      <v-card v-if="flag==2">
        <v-card-text class="pt-5">
          <p class="font-weight-black text-center" style="font-size:16px;"><v-icon class="mr-1 pb-1" color="red">mdi-alert-outline</v-icon>発送しないカードは還元されます</p>
          <p>選択されているカードを発送します。<span class="text-decoration-underline">選択されていないカードはポイントに還元され、保有ptに加算されます</span></p>
          <p class="text-left" style="font-size:12px;">発送カード <span class="font-weight-bold" style="font-size:16px;">{{selected.length}}</span> /{{cards.length}}枚</p>
          <v-row>
            <v-col><p class="text-left" style="font-size:12px;">還元カード <span class="font-weight-bold" style="font-size:16px;">{{cards.length-selected.length}}</span> /{{cards.length}}枚</p></v-col>
            <v-col><p class="text-right" style="font-size:12px;">計 <span class="font-weight-bold" style="font-size:16px;color:#bf9507;">{{nonselected_return_point}}</span> pt</p></v-col>
          </v-row>
          <v-btn block class="mt-5 mb-4 white--text" style="border:solid black;" color="#0086D2" @click="dialog=false;flag=0;deliveryCards();">確定する</v-btn>
          <v-btn block style="border:solid black;" @click="dialog=false;flag=0;">戻る</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import store from '../store'
import Api from '@/modules/api'

export default{
  name: 'Result',
  props: ['cards'],
  data(){
    return {
      selected: [],
      dialog: false,
      flag: 0,
    }
  },
  mounted: function(){
    if(this.cards == undefined) this.$router.push('/')
  },
  computed: {
    sum_return_point() {
      return this.cards.map(item => item.return_point)
                 .reduce((sum, element) => sum + element, 0);
    },
    nonselected_return_point() {
      return this.cards.filter(card => !this.selected.includes(card))
                 .map(item => item.return_point)
                 .reduce((sum, element) => sum + element, 0);
    },
  },
  methods: {
    ...mapActions(["openSnackbar", "closeSnackbar"]),
    getNextFriday: function(){
      // 現在の日付を取得
      var currentDate = new Date();
      // タイムゾーンを東京に設定
      var timeZoneOffset = 9 * 60; // GMT+9 (東京のタイムゾーンオフセットを分単位で指定)
      var currentOffset = currentDate.getTimezoneOffset(); // 現在のタイムゾーンオフセットを取得（分単位）
      currentDate.setMinutes(currentDate.getMinutes() + (timeZoneOffset + currentOffset)); // タイムゾーンオフセットを考慮して日付を調整
      // 現在の曜日を取得 (0 = 日曜日, 1 = 月曜日, ..., 6 = 土曜日)
      var currentDay = currentDate.getDay();
      // 次の日曜日までの日数を計算
      var daysUntilNextSunday = (5 + 7 - currentDay) % 7;
      // 次の日曜日の日付を計算
      var nextSundayDate = new Date(currentDate.getTime() + daysUntilNextSunday * 24 * 60 * 60 * 1000);
      // 次の日曜日の日付を表示 (YYYY-MM-DD形式)
      var formattedDate = (nextSundayDate.getMonth() + 1).toString().padStart(2, '0') + '/' + nextSundayDate.getDate().toString().padStart(2, '0');
      return formattedDate
    },
    select: function(card){
      let index = this.selected.map(item=>item.order_id).indexOf(card['order_id'])
      if(index == -1){
        this.selected.push(card)
      }else{
        this.selected.splice(index,1)
      } 
    },
    returnAllCards: function(){
      Api.postCardsReturn(this.cards).then(res => {
        this.openSnackbar('👏 +' + res['data'] +' pt')
        Api.getUser().then(()=>{
          Api.getMyCards().then(()=>{
            this.$router.push({
              name: 'complete',
              params: {
                cardsReturn: this.cards,
                cardsDelivery: []
              }
            })
          })
        })
      }).catch(err => {
        if(err.response?.status == 403) this.openSnackbar("アクセスが拒否されました")
      })
    },
    deliveryCards: function(){
      if(this.selected.length > 0){
        Api.putCardsDelivery('add',this.selected).then(() => {
          if(this.selected.length != this.cards.length){
            Api.postCardsReturn(this.cards.filter(card => !this.selected.includes(card))).then(res => {
              this.openSnackbar('👏 +' + res['data'] +' pt')
              Api.getUser().then(()=>{
                Api.getMyCards().then(()=>{
                  this.$router.push({
                    name: 'complete',
                    params: {
                      cardsReturn: this.cards.filter(card => !this.selected.includes(card)),
                      cardsDelivery: this.selected
                    }
                  })
                })
              })
            })
          }else{
            Api.getUser().then(()=>{
              Api.getMyCards().then(()=>{
                this.$router.push({
                  name: 'complete',
                  params: {
                    cardsReturn: this.cards.filter(card => !this.selected.includes(card)),
                    cardsDelivery: this.selected
                  }
                })
              })
            })
          }
        }).catch(err => {
          if(err.response?.status == 400){
            this.openSnackbar('🤔 配送先が登録されていません...')
            this.$router.push('/profile')
          }
        })
      }else if(this.selected.length == 0){
        this.returnAllCards()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.noisy-back {
  min-height: 100vh;
  background-color:#004B78;
  background-image: url(data:image/png;base64,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);  
  background-repeat: repeat;
} 
.font_rockn {
  font-family: 'RocknRoll One', sans-serif;
}

.transColor {
  background: rgba(0, 0, 0, 0);
}
.kira {
  box-shadow: 
    -20px -20px 30px -25px #ec9bb6, 
    20px 20px 30px -25px #ccac6f, 
    -7px -7px 10px -5px #ec9bb6, 
    7px 7px 10px -5px #ccac6f, 
    0 0 13px 4px rgba(255,255,255,0.3),
    0 55px 35px -20px rgba(0, 0, 0, 0.5);
}
.result_card {
  background: rgba(50, 70, 80, 0.7);
  overflow: hidden;
  height: 100%;
}
.card_background {
  position: absolute;
  z-index:1;
  opacity:0.2;
  top:50%;
  left:20%;
  width:70px;
  transform: translate(-50%, -50%) rotate(-20deg);
  -webkit-transform: translate(-50%, -50%) rotate(-20deg);
  -ms-transform: translate(-50%, -50%) rotate(-20deg);
}
.card_image {
  position: absolute;
  z-index:2;
  top:50%;
  left:10%;
  width:60px;
  transform: translate(-50%, -50%) rotate(-20deg);
  -webkit-transform: translate(-50%, -50%) rotate(-20deg);
  -ms-transform: translate(-50%, -50%) rotate(-20deg);
}

.result_footer {
  /*background: linear-gradient(to top, rgba(150, 150, 0, 0.85),transparent);*/
  color:white;
  border-top:solid;
  background: #004B78;
  padding:6px;
}
</style>